// AIDEV-NOTE: Custom highlight.js language subset for DevDocs. Only includes languages
// used in .claude/docs/ files. Add new languages here as needed — do NOT switch back to
// rehype-highlight's default `common` set (37 langs) to keep the lazy chunk small.
import bash from 'highlight.js/lib/languages/bash';
import css from 'highlight.js/lib/languages/css';
import diff from 'highlight.js/lib/languages/diff';
import javascript from 'highlight.js/lib/languages/javascript';
import json from 'highlight.js/lib/languages/json';
import markdown from 'highlight.js/lib/languages/markdown';
import plaintext from 'highlight.js/lib/languages/plaintext';
import ruby from 'highlight.js/lib/languages/ruby';
import scss from 'highlight.js/lib/languages/scss';
import shell from 'highlight.js/lib/languages/shell';
import sql from 'highlight.js/lib/languages/sql';
import typescript from 'highlight.js/lib/languages/typescript';
import xml from 'highlight.js/lib/languages/xml';
import yaml from 'highlight.js/lib/languages/yaml';

const languages = {
  bash,
  css,
  diff,
  javascript,
  json,
  markdown,
  plaintext,
  ruby,
  scss,
  shell,
  sql,
  typescript,
  xml,
  yaml,
};

export default languages;
